import { PopupTypes } from '../utils/constants';

const initialState = {
};

function app(state = initialState, action) {
    switch (action.type) {
        case 'POPUP:SHOW': {
            const { popup, entityType, id, onClosePopup, redirectTo, referringSurface, gatedFeature, renewalDate, prismicTitle } = action;
            return {
                ...state,
                [popup]: true,
                entityType,
                id,
                [`${popup}OnClosePopup`]: onClosePopup,
                [`${popup}RedirectTo`]: redirectTo,
                redirectTo,
                referringSurface,
                gatedFeature,
                renewalDate,
                prismicTitle,
            };
        }

        case 'POPUP:CLOSE': {
            const { popup } = action;
            const nextState = {
                ...state,
                [popup]: false,
                [`${popup}OnClosePopup`]: null,
                [`${popup}RedirectTo`]: null,
                redirectTo: null,
                referringSurface: null,
                gatedFeature: null,
                prismicTitle: null,
            };
            if (popup === PopupTypes.POWER_MONTHLY_UPGRADE_SUCCESS_POPUP) {
                delete nextState.renewalDate;
            }
            return nextState;
        }

        default:
            return state;
    }
}

export default app;
